import { useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop';
// import { ZoomInIcon, ZoomOutIcon } from 'lucide-react'; // dùng lucide-react hoặc bất kỳ icon nào bạn thích
import * as cts from '../../../constants/ui/svg';
import { createLocalImageFromUrl } from '../../../helpers/functionHelper';
import { IMAGE_BASE_URL_OF_USER } from '../../../constants';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getToken } from 'helpers';
import { rankingAction } from 'slices/rankingSlice';

type Props = {
  imageSrc: string;
  onCropComplete: any;
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  position: any;
  setPosition: React.Dispatch<React.SetStateAction<any>>;
  selectedStaff: any;
};

export default function ContentModalDefault({
  imageSrc,
  onCropComplete,
  zoom,
  setZoom,
  position,
  setPosition,
  selectedStaff,
}: Props) {
  const dispatch = useAppDispatch();
  const token = getToken() as string;


  const [imageStyle, setImageStyle] = useState<React.CSSProperties>({});

  const userStaff = useAppSelector((state) => state.ranking.userStaff);
  const imageShowRank = useAppSelector((state) => state.ranking.imageShowRank);
  const selectShop = useAppSelector((state) => state.shopList.selectShop);

  const onCropChange = useCallback((crop: any) => setPosition(crop), []);
  const onZoomChange = useCallback((z: number) => setZoom(z), []);
  const MIN_ZOOM = 1;
  const MAX_ZOOM = 3;
  const ZOOM_STEP = 0.2;
  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const { naturalWidth, naturalHeight } = e.currentTarget;

    // Set responsive style
    if (naturalWidth < naturalHeight) {
      setImageStyle({ width: '100%', height: 'auto' });
    } else {
      setImageStyle({ height: '100%', width: 'auto' });
    }
    // Set crop mặc định
  };
  useEffect(() => {
    if (selectedStaff?.id) {
      dispatch(
        rankingAction.getImageShowRanking({
          token,
          params: { shop_id: selectShop?.id, user_id: selectedStaff?.cid_user },
        })
      );
    }
  }, [selectedStaff?.id]);
  return (
    <div className="flex justify-center w-full h-[400px] items-center my-5">
      <div className="flex flex-col items-center">
        {/* Cropper */}
        <div className="w-[350px] h-[350px] relative">
          {
            // imageShowRank.length <= 0 &&
            typeof selectedStaff.imageUrl === 'string' && selectedStaff.imageUrl.trim() !== '' ? (
              <Cropper
                style={{ mediaStyle: { height: 'fit-content' } }}
                image={imageSrc}
                // image="https://img.huffingtonpost.com/asset/5ab4d4ac2000007d06eb2c56.jpeg?cache=sih0jwle4e&ops=1910_1000"
                crop={position}
                zoom={zoom}
                aspect={480 / 449}
                onCropChange={onCropChange}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
                // image={imageSrc}
                // crop={position}
                // zoom={zoom}
                // aspect={1} // Tỉ lệ cover Facebook (1200x600) là 2:1
                // // cropShape="rect"
                // cropShape="rect"
                // showGrid={false}
                // restrictPosition={false}
                // onCropChange={onCropChange}
                // onZoomChange={setZoom}
                // onCropComplete={onCropComplete}
              />
            ) : (
              <img
                className="w-full h-full"
                src={`${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${
                  selectedStaff.avatar_ranking || userStaff?.avatar_ranking
                }?v=${Date.now()}`}
              />
            )
          }
        </div>

        {/* Zoom slider dưới khung */}
        {imageShowRank.length <= 0 && selectedStaff?.imageUrl && (
          <div className="flex items-center justify-center gap-2 mt-4 w-full">
            {/* <button onClick={() => setZoom(zoom - 0.5)}>{cts.zoomOut}</button> */}
            <button
              onClick={() =>
                setZoom((prev) => Math.max(MIN_ZOOM, parseFloat((prev - ZOOM_STEP).toFixed(2))))
              }
              disabled={zoom <= MIN_ZOOM}
              className={`p-2 ${zoom <= MIN_ZOOM ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {cts.zoomOut}
            </button>
            <input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e) => onZoomChange(Number(e.target.value))}
              className="w-[55%] accent-gray-500"
            />
            <button
              onClick={() =>
                setZoom((prev) => Math.min(MAX_ZOOM, parseFloat((prev + ZOOM_STEP).toFixed(2))))
              }
              disabled={zoom >= MAX_ZOOM}
              className={`p-2 ${zoom >= MAX_ZOOM ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {cts.zoomIn}
            </button>
            {/* <button onClick={() => setZoom(zoom + 0.5)}>{cts.zoomIn}</button> */}
          </div>
        )}
      </div>
    </div>
  );
}
// import { useState, useCallback } from 'react';
// import Cropper from 'react-easy-crop';
// import { Area } from 'react-easy-crop';
// type Props = {
//   imageSrc: string;
//   zoom: any;
//   setZoom: any;
//   position: any;
//   setPosition: any;
//   onCropComplete: any;
// };
// const ContentModalDefault = ({ imageSrc, zoom, setZoom }: Props) => {
//   const [crop, setCrop] = useState({ x: 0, y: 0 });
//   // const [zoom, setZoom] = useState(1)
//   const onCropComplete = (croppedArea: Area, croppedAreaPixels: Area) => {
//     console.log(croppedArea, croppedAreaPixels);
//   };
//   return (
//     <div className="App">
//       <div className="crop-container w-[450px] h-[450px]">
//         <Cropper
//           style={{ mediaStyle: { height: 'fit-content' } }}
//           image={imageSrc}
//           // image="https://img.huffingtonpost.com/asset/5ab4d4ac2000007d06eb2c56.jpeg?cache=sih0jwle4e&ops=1910_1000"
//           crop={crop}
//           zoom={zoom}
//           aspect={1}
//           onCropChange={setCrop}
//           onCropComplete={onCropComplete}
//           onZoomChange={setZoom}
//         />
//       </div>
//       <div className="controls">
//         <input
//           type="range"
//           value={zoom}
//           min={1}
//           max={3}
//           step={0.1}
//           aria-labelledby="Zoom"
//           onChange={(e) => {
//             // setZoom(e.target.value)
//           }}
//           className="zoom-range"
//         />
//       </div>
//     </div>
//   );
// };
// export default ContentModalDefault;
